<template>
  <div style="display: flex">
    <el-select
      v-model="form.brandid"
      filterable
      remote
      reserve-keyword
      placeholder="请选择品牌"
      :loading="loading"
      @change="getSeriesSearch"
    >
      <el-option
        v-for="item in brandList"
        :key="item.id"
        :label="item.brand_name"
        :value="item.id"
      >
        <span style="float: left">{{ item.brand_name }}</span>
        <span style="float: right; color: #8492a6; font-size: 13px">{{
          item.brand_index
        }}</span>
      </el-option>
    </el-select>
    <el-select
      v-if="searchType > 1"
      v-model="form.seriesid"
      filterable
      remote
      reserve-keyword
      placeholder="请选择车系"
      :loading="loading"
      @change="geModelSearch"
    >
      <el-option
        v-for="item in seriesList"
        :key="item.id"
        :label="item.series_name"
        :value="item.id"
      >
      </el-option>
    </el-select>
    <el-select
      v-if="searchType > 2"
      v-model="form.modelid"
      filterable
      remote
      reserve-keyword
      placeholder="请选择车型"
      :loading="loading"
      @change="modelChange"
    >
      <el-option
        v-for="item in modelList"
        :key="item.id"
        :label="item.model_name"
        :value="item.id"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import {
  car_brand_search,
  car_series_search,
  car_model_search,
} from "../../api/api";
export default {
  name: "car-search",
  props: {
    inputList: {
      default: function () {
        return [];
      },
    },
    searchType: Number,
  },
  data() {
    return {
      loading: false,
      options: [],
      brandList: [],
      seriesList: [],
      modelList: [],
      brand_arr: [],
      form: [],
    };
  },
  created() {
    if (this.inputList.brandid) {
      this.form.brandid = this.inputList.brandid;
    }
    if (this.inputList.get_series)
      this.form.seriesid = this.inputList.get_series.series_name;
      // console.log("数据",this.inputList.get_series)
      if(this.inputList.get_series != undefined){
        if(this.inputList.get_series.brandid){
          this.form.brandid = this.inputList.get_series.brandid;
        }
      }
      
    if (this.inputList.get_model)
      this.form.modelid = this.inputList.get_model.model_name;
    this.getBrandSearch();
  },
  methods: {
    getBrandSearch() {
      //品牌搜索
      this.loading = true
      car_brand_search().then((msg) => {
        let { data } = msg;
        data = JSON.parse(data).data;
        this.brandList = data;
        this.loading = false
      });
    },
    getSeriesSearch() {
      //车系搜索
      if (this.searchType < 2) {
        this.brand_arr = this.brandList.filter((item)=>item.id === this.form.brandid) || [{'brand_name': null}];
        this.form.brand_name = this.brand_arr[0].brand_name;
        this.$forceUpdate(); //强制更新视图
        this.$emit("increment", this.form);
        return;
      }
      car_series_search({"brandid":this.form.brandid}).then((msg) => {
        let { data } = msg;
        data = JSON.parse(data).data;
        this.seriesList = data;
      });
      this.$emit("increment", this.form);
    },
    geModelSearch() {
      //车型搜索
      if (this.searchType == 2) {
        this.getSeriesSearch();
      } else {
        //刷新车系
        car_model_search({"seriesid":this.form.seriesid}).then((msg) => {
          let { data } = msg;
          data = JSON.parse(data).data;
          this.modelList = data;
        });
      }

      this.$emit("increment", this.form);
    },
    modelChange() {
      this.geModelSearch();
      this.$emit("increment", this.form);
    },
  },
  watch: {
    brandid(newValue, oldValue) {
      console.log(newValue);
    },
  },
};
</script>

<style scoped lang="scss">
.el-select {
  width: 100%;
}
</style>
<style>
</style>
